import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ApiFormActions = ({ action, submitting, onCreate, onUpdate, onDelete }) => {
  const { t } = useTranslation("common");

  if (action === "view") {
    return null;
  }

  return (
    <div className="form-view-actions">
      {action === "create" ? (
        <button
          type="button"
          className="btn btn-primary"
          onClick={onCreate}
          disabled={submitting}>
          {submitting ? `${t("Create")}...` : t("Create")}
        </button>
      ) : null}
      {action === "update" ? (
        <button
          type="button"
          className="btn btn-primary"
          onClick={onUpdate}
          disabled={submitting}>
          {submitting ? `${t("Update")}...` : t("Update")}
        </button>
      ) : null}
      {action === "delete" ? (
        <button
          type="button"
          className="btn btn-danger"
          onClick={onDelete}
          disabled={submitting}>
          {submitting ? `${t("Delete")}...` : t("Delete")}
        </button>
      ) : null}
    </div>
  );
};

ApiFormActions.propTypes = {
  action: PropTypes.string.isRequired,
  submitting: PropTypes.bool,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func
};

ApiFormActions.defaultProps = {
  submitting: false,
  onCreate: undefined,
  onUpdate: undefined,
  onDelete: undefined
};

export default ApiFormActions;
